   import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const KotakMahindraBikeEMiCalculator   = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the purpose of a bike loan EMI calculator?",
            "answer": "It helps estimate your monthly EMI based on loan variables, ensuring smart budgeting."
          },
          {
            "question": "Is the EMI calculator specific to Kotak Mahindra Bank?",
            "answer": "Yes, TheFinMaster tailors the tool according to Kotak’s interest rates and loan policies."
          },
          {
            "question": "Is this EMI result 100% accurate?",
            "answer": "It’s highly accurate but subject to minor variations based on actual bank charges."
          },
          {
            "question": "Can I use this calculator on mobile?",
            "answer": "Absolutely. TheFinMaster’s EMI Calculator is mobile-friendly and responsive."
          },
          {
            "question": "Does it include processing fees?",
            "answer": "No, but you can add it manually to understand the total cost."
          },
          {
            "question": "How often can I use the calculator?",
            "answer": "Unlimited times. Try different scenarios for better clarity."
          },
          {
            "question": "Can I compare loans with this calculator?",
            "answer": "Yes, adjust tenure or amount and compare the EMIs easily."
          },
          {
            "question": "What’s the ideal EMI-to-income ratio?",
            "answer": "Ideally, your EMI should not exceed 30-40% of your monthly income."
          },
          {
            "question": "Can I calculate prepayment impact?",
            "answer": "Not directly, but we recommend checking our Prepayment Calculator for that."
          },
          {
            "question": "Does Kotak offer fixed or floating bike loan interest?",
            "answer": "Mostly fixed rates, but check with the bank for current terms."
          },
          {
            "question": "What if interest rates change post-loan approval?",
            "answer": "In fixed-rate loans, EMI remains constant regardless of rate changes."
          },
          {
            "question": "What documents are required for the loan?",
            "answer": "Identity proof, address proof, income proof, bank statements, and quotation from the bike dealer."
          },
          {
            "question": "How do I apply for a bike loan from Kotak Mahindra Bank?",
            "answer": "Visit the nearest branch or apply online via the official portal or TheFinMaster’s link."
          },
          {
            "question": "What’s the usual processing time?",
            "answer": "Typically 2–3 working days if all documents are in order."
          },
          {
            "question": "Can I foreclose the loan early?",
            "answer": "Yes, but foreclosure charges may apply based on loan agreement terms."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Kotak Mahindra Bike Loan EMI Calculator – Simple EMI Computation</title>
        <meta  name='description' content='Quickly estimate your Kotak Mahindra bike loan EMIs. Use this tool to plan your two-wheeler finance effectively.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/kotak-mahindra-bank-bike-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Kotak Mahindra Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">Kotak Mahindra Bike Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Kotak Mahindra Bank Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            If you're planning to purchase a new two-wheeler and considering Kotak Mahindra Bank for your loan, understanding your financial commitment becomes essential. TheFinMaster’s Bike Loan EMI Calculator for Kotak Mahindra Bank empowers you to assess your monthly outflows and plan your budget effectively. With just a few inputs like loan amount, interest rate, and tenure, you can calculate your estimated EMIs instantly and tailor your loan accordingly. This tool is particularly beneficial for first-time buyers, enabling a transparent and stress-free loan planning experience.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Bike Loan EMI (Equated Monthly Installment) is the fixed amount you pay every month towards the repayment of your two-wheeler loan. It includes two components:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Principal Repayment</strong> – The part of EMI that reduces the original loan amount.</li>
              <li><strong>Interest Component</strong> – The cost you pay to the lender for borrowing the money.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Over time, the interest portion reduces while the principal component increases with each payment, following the amortization process. Knowing your EMI in advance gives you financial control and prevents surprises, making it easier to manage your monthly expenses and savings.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Kotak Mahindra Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Kotak Mahindra Bank Bike Loan EMI Calculator by TheFinMaster is a smart, easy-to-use online tool that allows you to compute your EMIs before taking the loan. It eliminates the need for complex manual calculations by providing instant results based on your inputs. Whether you're purchasing a high-end sports bike or a daily commuter, this tool simplifies your decision-making by showing the monthly outflow clearly.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator is tailored to reflect Kotak Mahindra Bank’s loan policies, such as interest rate ranges, tenure flexibility, and processing charges, so the results are highly relevant and actionable.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Kotak Mahindra Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s EMI Calculator gives you an edge when planning your two-wheeler purchase. Here's why it's beneficial:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Time-Efficient:</strong> Instantly calculates EMIs within seconds.</li>
              <li><strong>Accurate Forecasting:</strong> Gives a near-exact idea of your monthly financial obligation.</li>
              <li><strong>Scenario Planning:</strong> Lets you compare different loan amounts, interest rates, and tenures.</li>
              <li><strong>Informed Decisions:</strong> Helps you decide the ideal loan structure that fits your budget.</li>
              <li><strong>Transparency:</strong> Avoid surprises by knowing your dues beforehand.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              With this clarity, you can plan your purchase and repayment without second-guessing or financial strain.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Kotak Mahindra Bank Bike Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator works using the basic EMI formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan amount</li>
              <li>R = Monthly interest rate (Annual Rate/12/100)</li>
              <li>N = Loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Let’s say:<br />
              Loan Amount = ₹1,20,000<br />
              Interest Rate = 11% p.a.<br />
              Tenure = 24 months<br />
              Monthly Interest Rate = 11 / 12 / 100 = 0.0091667<br />
              EMI = [120000 x 0.0091667 x (1+0.0091667)^24] / [(1+0.0091667)^24 – 1] ≈ ₹5,616<br />
              This means you will pay ₹5,616 every month for 2 years to repay the loan in full.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a complete breakdown of your bike loan repayment plan over the entire tenure. It outlines the EMI breakup month-wise, showing how much goes towards interest and how much towards the principal every month. In early months, a larger portion of EMI goes toward interest, gradually shifting to principal repayment in later months. This table provides full transparency and helps you see the repayment journey clearly.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Illustrative):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">Opening Balance</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Closing Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">1,20,000</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">1,100</td>
                    <td className="border px-4 py-2">9,507</td>
                    <td className="border px-4 py-2">1,10,493</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">1,10,493</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">1,015</td>
                    <td className="border px-4 py-2">9,592</td>
                    <td className="border px-4 py-2">1,00,901</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">1,00,901</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">924</td>
                    <td className="border px-4 py-2">9,683</td>
                    <td className="border px-4 py-2">91,218</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">91,218</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">834</td>
                    <td className="border px-4 py-2">9,773</td>
                    <td className="border px-4 py-2">81,445</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">81,445</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">745</td>
                    <td className="border px-4 py-2">9,862</td>
                    <td className="border px-4 py-2">71,583</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">71,583</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">657</td>
                    <td className="border px-4 py-2">9,950</td>
                    <td className="border px-4 py-2">61,633</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">61,633</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">569</td>
                    <td className="border px-4 py-2">10,038</td>
                    <td className="border px-4 py-2">51,595</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">51,595</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">477</td>
                    <td className="border px-4 py-2">10,130</td>
                    <td className="border px-4 py-2">41,465</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">41,465</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">390</td>
                    <td className="border px-4 py-2">10,217</td>
                    <td className="border px-4 py-2">31,248</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">31,248</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">297</td>
                    <td className="border px-4 py-2">10,310</td>
                    <td className="border px-4 py-2">20,938</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">20,938</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">193</td>
                    <td className="border px-4 py-2">10,414</td>
                    <td className="border px-4 py-2">10,524</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">10,524</td>
                    <td className="border px-4 py-2">10,607</td>
                    <td className="border px-4 py-2">97</td>
                    <td className="border px-4 py-2">10,510</td>
                    <td className="border px-4 py-2">14</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Balance  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "₹5,274", "₹4,774", "₹500", "₹55,226"],
          ["2", "₹5,274", "₹4,814", "₹460", "₹50,412"],
          ["3", "₹5,274", "₹4,854", "₹420", "₹45,558"],
          ["4", "₹5,274", "₹4,894", "₹380", "₹40,664"],
          ["5", "₹5,274", "₹4,935", "₹339", "₹35,729"],
          ["6", "₹5,274", "₹4,976", "₹298", "₹30,753"],
          ["7", "₹5,274", "₹5,017", "₹257", "₹25,736"],
          ["8", "₹5,274", "₹5,059", "₹215", "₹20,677"],
          ["9", "₹5,274", "₹5,101", "₹173", "₹15,576"],
          ["10", "₹5,274", "₹5,143", "₹131", "₹10,433"],
          ["11", "₹5,274", "₹5,185", "₹89", "₹5,248"],
          ["12", "₹5,274", "₹5,248", "₹26", "₹0"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
             ["1", "₹5,274", "₹4,774", "₹500", "₹55,226"],
             ["2", "₹5,274", "₹4,814", "₹460", "₹50,412"],
             ["3", "₹5,274", "₹4,854", "₹420", "₹45,558"],
             ["4", "₹5,274", "₹4,894", "₹380", "₹40,664"],
             ["5", "₹5,274", "₹4,935", "₹339", "₹35,729"],
             ["6", "₹5,274", "₹4,976", "₹298", "₹30,753"],
             ["7", "₹5,274", "₹5,017", "₹257", "₹25,736"],
             ["8", "₹5,274", "₹5,059", "₹215", "₹20,677"],
             ["9", "₹5,274", "₹5,101", "₹173", "₹15,576"],
             ["10", "₹5,274", "₹5,143", "₹131", "₹10,433"],
             ["11", "₹5,274", "₹5,185", "₹89", "₹5,248"],
             ["12", "₹5,274", "₹5,248", "₹26", "₹0"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Balance(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Note: Numbers are illustrative based on an approximate interest rate of 11%.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> A higher loan results in higher EMIs, though you may benefit from lower interest rates for larger amounts.</li>
                <li><strong>Interest Rate:</strong> Even a small increase in interest rate can lead to significantly higher EMIs.</li>
                <li><strong>Tenure:</strong> Longer loan durations reduce monthly EMI amounts but increase total interest outgo.</li>
                <li><strong>Processing Fees:</strong> These are one-time fees but add to your upfront cost and indirectly impact affordability.</li>
                <li><strong>Prepayments:</strong> Making partial payments during the tenure or closing the loan early can reduce interest burden.</li>
                <li><strong>Credit Score:</strong> A higher CIBIL score often qualifies you for lower interest rates.</li>
                <li><strong>Income Stability:</strong> Lenders may offer flexible EMIs and longer tenures based on your income and employment status.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                        {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default KotakMahindraBikeEMiCalculator ;
